export const environment = {
  production: true,
  stripeProdKey: 'pk_live_51NqnEADy08ANYAYJCWKFFsxrc0MTUnGCG9MKEmZobqCXklkZVjCrlccxlmiFtfKgcHMLjJCL9sK8Gxza3rIRpoGa00A0AIgevC'
};
